import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "motion/react";
import "../Styles/PlanePreloader.css";

export default function PlanePreloader({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [isExiting, setIsExiting] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    // Smooth progress from 0 to 100%
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 2;
      });
    }, 22);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (progress < 100) return;

    const exitTimer = setTimeout(() => {
      setIsExiting(true);
      if (onComplete) onComplete();
    }, 150);

    const finishTimer = setTimeout(() => {
      setIsFinished(true);
    }, 700);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(finishTimer);
    };
  }, [progress, onComplete]);

  if (isFinished) return null;

  return (
    <AnimatePresence>
      {!isFinished && (
        <motion.div
          className={`plane-preloader-overlay ${isExiting ? "exiting" : ""}`}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <div className="minimal-flight-container">
            {/* Minimal Flight Path and Plane */}
            <div className="flight-track">
              {/* Contrail trail behind the plane */}
              <div 
                className="plane-contrail" 
                style={{ width: `${progress}%` }} 
              />

              {/* The Single Flying Plane */}
              <div 
                className="single-flying-plane"
                style={{ 
                  left: `${progress}%`,
                }}
              >
                <svg
                  className="plane-svg-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 16V14L13 9V3.5C13 2.67 12.33 2 11.5 2C10.67 2 10 2.67 10 3.5V9L2 14V16L10 13.5V19L8 20.5V22L11.5 21L15 22V20.5L13 19V13.5L21 16Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>

            {/* Clean, subtle progress indicator */}
            <div className="minimal-loader-footer">
              <span className="minimal-brand">VE ABROAD</span>
              <span className="minimal-percent">{progress}%</span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
